// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__11c0X"};